/**
*
* UserProfile
*
*/

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  HOCs,
} from '@pearsontechnology/aero-components';

import { selectCurrentMe } from 'data/CurrentUser/selectors';

import {
  Wrapper,
  AvatarWrapper,
} from './styles';

import UserProfileMenu from '../UserProfileMenu';

const { enhanceWithPopper } = HOCs;
const AvatarWithPopper = enhanceWithPopper(AvatarWrapper);

function UserProfile({ me, ...props }) {
  const avatar = me || {};

  return (
    <Wrapper {...props}>
      <AvatarWithPopper placement="bottom-end" avatar={avatar}>
        <UserProfileMenu />
      </AvatarWithPopper>
    </Wrapper>
  );
}

UserProfile.propTypes = {
  me: PropTypes.object,
};

const mapStateToProps = (state) => {
  const me = selectCurrentMe(state);
  return {
    me,
  };
};

export default connect(mapStateToProps)(UserProfile);
